import React, { useState } from 'react';

import { LocalizedLink } from '../primitives';
import { BackgroundImage, Input } from '../primitives';
import WrappedButton from '../primitives/wrappedButton/WrappedButton';

export default function ContentSingle(props: { block: any }) {
    const { block } = props;

    const [searchValue, setSearchValue] = useState<string>('');

    return (
        <div className='blockContentSingle'>
            <div className='overlay'></div>

            <BackgroundImage fileName={block.background.src} />

            <div className={`container ${block.align ? block.align : ''}`}>
                {block.title && <h2>{block.title}</h2>}

                {block.subtitle && <p className='subtitle'>{block.subtitle}</p>}

                {block.p && <p>{block.p}</p>}

                {block.searchGroup && (
                    <div className='searchGroup'>
                        <Input
                            placeholder={block.searchGroup.placeholder}
                            value={searchValue}
                            onChange={(value: string) => setSearchValue(value)}
                        />
                        {searchValue ? (
                            <LocalizedLink
                                className='linkto'
                                to={'/installer/?searchValue=' + searchValue}
                            >
                                {block.searchGroup.buttonLabel}
                            </LocalizedLink>
                        ) : (
                            <LocalizedLink className='linkto' to='/installer/'>
                                {block.searchGroup.buttonLabel}
                            </LocalizedLink>
                        )}
                    </div>
                )}

                {block.buttonLabel && (
                    <WrappedButton
                        className={block.btnAlign ? block.btnAlign : ''}
                        label={block.buttonLabel}
                        link={block.buttonLink}
                    />
                )}
            </div>
        </div>
    );
}
